import React from 'react'

type Props = {
  className?: string
}

const SmallBusiness = ({ className }: Props) => (
  <svg width="48" height="49" viewBox="0 0 48 49" fill="none" className={className}>
    <g clipPath="url(#clip0_190_619)">
      <path
        d="M44.769 12.5626L40 6.84064V1.20264C40 0.93742 39.8946 0.683066 39.7071 0.49553C39.5196 0.307994 39.2652 0.202637 39 0.202637L9 0.202637C8.73478 0.202637 8.48043 0.307994 8.29289 0.49553C8.10536 0.683066 8 0.93742 8 1.20264V6.84064L3.231 12.5626C3.08156 12.7424 2.99982 12.9689 3 13.2026V17.2026C3 17.4679 3.10536 17.7222 3.29289 17.9097C3.48043 18.0973 3.73478 18.2026 4 18.2026H8V47.2026C8 47.4679 8.10536 47.7222 8.29289 47.9097C8.48043 48.0973 8.73478 48.2026 9 48.2026H40V18.2026H44C44.2652 18.2026 44.5196 18.0973 44.7071 17.9097C44.8946 17.7222 45 17.4679 45 17.2026V13.2026C45.0002 12.9689 44.9184 12.7424 44.769 12.5626ZM10 2.20264H38V6.20264H10V2.20264ZM30.479 8.20264L36.079 16.2026H25V8.20264H30.479ZM23 8.20264V16.2026H11.921L17.521 8.20264H23ZM5 16.2026V13.5646L9.469 8.20264H15.079L9.479 16.2026H5ZM38 46.2026H10V40.2026H38V46.2026ZM14 38.2026V22.2026H24V38.2026H14ZM38 38.2026H26V21.2026C26 20.9374 25.8946 20.6831 25.7071 20.4955C25.5196 20.308 25.2652 20.2026 25 20.2026H13C12.7348 20.2026 12.4804 20.308 12.2929 20.4955C12.1054 20.6831 12 20.9374 12 21.2026V38.2026H10V18.2026H38V38.2026ZM43 16.2026H38.521L32.921 8.20264H38.531L43 13.5646V16.2026Z"
        fill="#2979FF"
      />
      <path d="M25 42.2026H23V44.2026H25V42.2026Z" fill="#2979FF" />
      <path d="M22 30.2026H20V32.2026H22V30.2026Z" fill="#2979FF" />
      <path
        d="M29 32.2026H35C35.2652 32.2026 35.5196 32.0973 35.7071 31.9097C35.8946 31.7222 36 31.4679 36 31.2026V21.2026C36 20.9374 35.8946 20.6831 35.7071 20.4955C35.5196 20.308 35.2652 20.2026 35 20.2026H29C28.7348 20.2026 28.4804 20.308 28.2929 20.4955C28.1054 20.6831 28 20.9374 28 21.2026V31.2026C28 31.4679 28.1054 31.7222 28.2929 31.9097C28.4804 32.0973 28.7348 32.2026 29 32.2026ZM30 22.2026H34V25.2026H30V22.2026ZM30 27.2026H34V30.2026H30V27.2026Z"
        fill="#2979FF"
      />
      <path d="M36 34.2026H28V36.2026H36V34.2026Z" fill="#2979FF" />
    </g>
    <defs>
      <clipPath id="clip0_190_619">
        <rect width="48" height="48" fill="white" transform="translate(0 0.202637)" />
      </clipPath>
    </defs>
  </svg>
)

export default SmallBusiness
